export default __webpack_public_path__ + "static/media/horse-background.7fee5614.svg";